import { apiPaths } from 'app/services/api';
import React from 'react';
import CrudGridForm from '../../smart-kit/Form/CrudGridForm';

export const warrantyFields = [
  {
    label: 'Store',
    key: 'store_uuid',
    type: 'auto_complete',
    options: { entity: 'stores', path: apiPaths.STORES },
    // show: { key: 'type', value: 'organisational' },
  },
  { label: 'Warranty Number', mod: 'edit', key: 'warranty_number', validation: { required: true } },
  {
    label: 'شماره سریال از',
    mod: 'add',
    key: 'warranty_number_from',
    validation: { required: true },
    placeholder: '01',
  },
  {
    label: 'شماره سریال تا',
    mod: 'add',
    key: 'warranty_number_to',
    validation: { required: true },
    placeholder: '10',
  },

  //   {
  //     label: 'شماره سریال‌ها(در هر خط یک شماره قرار دهید)',
  //     mod: 'add',
  //     key: 'warranty_numbers',
  //     type: 'multiline',
  //     validation: { required: true },
  //     placeholder: `GPM0201
  // GPM0202
  // GPM0203

  //   `
  //   }
];
const WarrantyCardForm = () => {
  return (
    <CrudGridForm
      path={apiPaths.WARRANTIES}
      name="Warranty"
      entityName={'warranties'}
      fields={warrantyFields}
    />
  );
};

export default WarrantyCardForm;
